module.exports = __webpack_public_path__ + "static/5-253d07b4fad291b84b5a944ac852c30c.jpeg";